
import moment from 'moment'
import * as _ from 'lodash'
import 'bootstrap-daterangepicker'
import 'bootstrap-daterangepicker/daterangepicker.css'
import 'swiped-events/dist/swiped-events.min.js'

var goCardlessCountries = []
var selectedCountry
var institutions = []
var selectedInstitutionId
var importInterval
var LockBankSelector = false
var PrivacyTimer

if (document.querySelector("#bank-selector-modal") !== null) {
    document.addEventListener("appReady", () => {
        if (DEBUG) console.log(('Initializing topbar'))
        initTopbarPage()
    })   

    document.querySelector("#bank-selector-modal").addEventListener("bankSelectorLocked", () => {
        console.log('Locked !')
        LockBankSelector = true
    })

    document.querySelector("#bank-selector-modal").addEventListener("bankSelectorUnlocked", () => {
        console.log('Unlocked !')
        LockBankSelector = false
    })
}

function importLoop(referenceId) {
    $.ajax({
        url: 'json/new-online-account-import',
        method: 'POST',
        data: { ref: referenceId, _csrf: $("meta[name=_csrf]").attr("content") },
        success: function (response) {   
            if (DEBUG) console.log(response)

            $('#bank-selector-modal-title').text(global.i18n.t('accounts.bankSelector.onlineAccountFeedback.please_wait'))
            let output = `
                <div class="col-12">
                    <div class="card mb-1 border-0">
                        <div class="row g-0">
                            <div class="col-md-4 d-flex justify-content-center align-items-center">
                                <div class="spinner-border img-flui avatar-xl text-primary" role="status"></div>
                            </div>
                            <div class="col-md-8">
                                <div class="card-body pe-2">
                                    <h3 class="card-title p-0 m-0"><span id="import-req">${global.i18n.t('accounts.bankSelector.onlineAccountFeedback.requisition')}</span> <div id="import-spinner-1" class="spinner-border spinner-border-sm text-success mx-1 visually-hidden" role="status"></div></h3>
                                    <p class="card-text"><small class="text-muted">${global.i18n.t(`accounts.bankSelector.onlineAccountFeedback.${response.requisition}`)}</small></p>
                                    <h3 class="card-title p-0 m-0"><span id="import-acc">${global.i18n.t('accounts.bankSelector.onlineAccountFeedback.account', {count: 2})}</span><div id="import-spinner-2" class="spinner-border spinner-border-sm text-success mx-1 visually-hidden" role="status"></div></h3>
                                    <p class="card-text"><small class="text-muted">${global.i18n.t(`accounts.bankSelector.onlineAccountFeedback.transactions_sync`)}</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            `
        
            $('.institutions-cards').html(output)


            if (typeof response.accounts === 'undefined') {
                $('#import-spinner-1').removeClass('visually-hidden')
                $('#import-spinner-2').addClass('visually-hidden')
            } else {
                $('#import-spinner-1').addClass('visually-hidden')
                $('#import-spinner-2').removeClass('visually-hidden')
            }

            if (Object.keys(response).length > 0 && typeof response.done !== 'undefined') {
                clearInterval(importInterval)

                window.location.reload()
            }
        },
        error: function (err) {
            helpers.alert(err)
        }
    })
}

function initTopbarPage() {
    document.querySelector(".navbar-custom").addEventListener('swiped-down', function(e) {
        window.location.reload()
    })
    
    $('.data-privacy').off().on('click', function(e) {
        globals.vars.privacyMode = !globals.vars.privacyMode

        if (globals.vars.privacyMode == true) {
            helpers.appSettingsSet({'privacyMode': true})
            $('.data-privacy').find('i').removeClass('mdi-eye-off').addClass('mdi-eye')
    
            $('.amount').each(function() {
                const value = $(this).text()
                $(this).attr('data-amount-value', value)
                $(this).text(helpers.anonFigures(value))
            })

            return window.location.reload()
        } else {
            helpers.appSettingsDelete('privacyMode')

            return window.location.reload()

            $('.amount').each(function() {
                const value = $(this).attr('data-amount-value')

                if (typeof PrivacyTimer !== 'undefined')
                    return
                
                if (typeof value === 'undefined') {
                    PrivacyTimer = setTimeout(function() {
                        window.location.reload()
                    }, 100)

                    return 
                }

                $(this).text(value)
                $(this).removeAttr('data-amount-value')
            })


//            
        }
    })

    if (globals.vars.privacyMode)
        $('.data-privacy').find('i').removeClass('mdi-eye-off').addClass('mdi-eye')

    const newAccountRefId = $("meta[name=link-account-ref]").attr("content")

    if (typeof newAccountRefId !== 'undefined')
        $('#bank-selector-modal').modal('show')


    const myModal = document.getElementById('bank-selector-modal')

    myModal.addEventListener('shown.bs.modal', () => {
        if (typeof newAccountRefId !== 'undefined') {
            clearInterval(importInterval)
            importInterval = setInterval(function() {
                importLoop(newAccountRefId)
            }, 5000)
        } else {
            generateLoading()
            generateCountries()
        }
    })

    myModal.addEventListener('hide.bs.modal', () => {
        generateLoading()
    })

    generateLoading()

    if (typeof newAccountRefId !== 'undefined') {
        importLoop(newAccountRefId)
        $('#bank-modal-search-container').closest('div').addClass('visually-hidden')
        $('#bank-selector-modal').modal('show')
    }
    
    $('#inst-back-1-btn').off().on('click', function(e) {
        e.preventDefault()
        generateCountries()
    })

    $('#inst-back-2-btn').off().on('click', function(e) {
        e.preventDefault()
        generateInstitutions()
    })

    $('#accBalDate').daterangepicker({
        startDate: moment(),
        maxDate: moment().add('2 months').endOf('month'),
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        timePickerSeconds: true,
        opens: "right",
        drops: "auto",
        autoApply: true,
        showDropdowns: true,
        buttonClasses: ['btn', 'btn-sm'],
        applyClass: 'btn-primary',
        cancelClass: 'btn-light',
        locale: {
            format: "YYYY-MM-DD HH:mm:ss",
            fromLabel: global.i18n.t('transactions.dateRangePicker.from'),
            toLabel: global.i18n.t('transactions.dateRangePicker.to'),
            applyLabel: global.i18n.t('buttons.apply'),
            cancelLabel: global.i18n.t('buttons.cancel'),
            customRangeLabel: global.i18n.t('transactions.dateRangePicker.custom'),
            daysOfWeek: global.i18n.t('transactions.dateRangePicker.daysOfWeek', { returnObjects: true }),
            monthNames: global.i18n.t('transactions.dateRangePicker.monthNames', { returnObjects: true }),
            firstDay: 1
        }
    }, function(start) {
        //console.log(moment(start).toISOString())
       
    })


    let select2Data = []

    for (let i=0; i<globals.vars.userData.accounts.length; i++) {
        if (globals.vars.userData.accounts[i]['archived'])
            continue

        select2Data.push({
            id: globals.vars.userData.accounts[i]._id,
            text: globals.vars.userData.accounts[i].custom_name != '' ? globals.vars.userData.accounts[i].custom_name : globals.vars.userData.accounts[i].name,
        })
    }

    $('#selectTop').select2({
        tags: false,
        data: select2Data,
        dropdownParent: $('#account-balance-modal')
    })


    $('#new-account-balance-lnk').off().on('click', function(e) {
        e.preventDefault()

        const accountId = helpers.appSettingsGet('transactionsAccountId')

        if (accountId !== null && accountId.substring(0 ,1) !== '@') {
            $('#selectTop').val(accountId)
            $('#selectTop').trigger('change')
        }

        $('#deleteAccBalBtn').hide()
        $('#accBal_id').val(crypto.randomUUID())
        $('#accBalAmount').val('')
        $('#accBalDate').data('daterangepicker').setStartDate(moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'))
        $('#accBalComment').val('')
    })

    $('#saveAccBalBtn').off().on('click', function(e) {
        e.preventDefault()

        if ($('#accBalAmount').val() == '' || $('#accBalDate').val() == '')
            return

        $('#account-balance-modal').modal('hide')

        const isUpdate = $('#deleteAccBalBtn').is(':visible') ? true : false

        const params = {
            item: {
                _id: isUpdate ? $('#accBal_id').val() : '',
                accountId: $('#selectTop').val(),
                transactionAmount: {
                    amount: $('#accBalAmount').val(),
                    currency: globals.vars.userData.accountsById[$('#selectTop').val()].currency,
                    exchange_rate: ""
                },
                date: { booked: moment($('#accBalDate').val()).toISOString(), reported: moment($('#accBalDate').val()).toISOString() },
                comment: $('#accBalComment').val(),
                isAccountBalance: true,
                paid: false,
                statistic: false,
            },
            _csrf: $("meta[name=_csrf]").attr("content")
        }
    
        const _url = isUpdate ? '/json/transaction/update' : '/json/transaction/insert'
    
        $.ajax({
            url: _url,
            method: 'POST',
            data: params,
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)

                var table = $('#transactions-datatable').DataTable()
                table.ajax.reload().draw('full-hold')
            },
            error: function (err) {
                helpers.alert(err)
            }
        })

    })

    $('#deleteAccBalBtn').off().on('click', function(e) {
        e.preventDefault()

        const params = {
            item: {
                _id: $('#accBal_id').val()
            },
            _csrf: $("meta[name=_csrf]").attr("content")
        }
    
        $.ajax({
            url: '/json/transaction/delete',
            method: 'POST',
            data: params,
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)

                var table = $('#transactions-datatable').DataTable()
                table.ajax.reload().draw('full-hold')
            },
            error: function (err) {
                helpers.alert(err)
            }
        })

        $('#account-balance-modal').modal('hide')
    })

    if (typeof $('#transactions').attr('id') !== 'undefined')
        $('#new-transaction-lnk').closest('.dropdown').removeClass('visually-hidden')

    $('#new-transaction-lnk').off().on('click', function(e) {

        $('#f_statistic').prop('checked', true)
        $('#f_paid').prop('checked', false)
        $('#f_amount').val('')

        
        $('#f_date').data('daterangepicker').setStartDate(moment().format('YYYY-MM-DD HH:mm:ss'))

        const _sel = helpers.appSettingsGet('transactionsAccountId')

        if (_sel !== null) {
            $('#f_account').val(_sel)
            $('#f_account').trigger('change')
        }

        $('#f_comment').val('')
        $('#f_title').val('')
        $('#f_receiver').val('')
        $('#f_usage').val('')
        $('#f_category').val('')
        $('#f_tags').val('')

        $('#copy-transaction-btn').hide()
        $('#delete-transaction-btn').hide()

        $('#_id').val('')
    })

    function generateLoading() {
        let output = ''

        output += `
            <div class="col-12 p-5">
                <div class="p-5 text-center">
                    <div class="text-center"><div class="spinner-grow text-primary m-2" role="status"></div><div class="spinner-grow text-warning m-2 d-none d-sm-inline-block" role="status"></div><div class="spinner-grow text-danger m-2 d-none d-sm-inline-block" role="status"></div></div>
                </div>
            </div>
            `
        $('.institutions-cards').html(output)
    }


    function generateCountries() {
        $('#inst-back-1-btn').addClass('visually-hidden')

        $('#bank-selector-modal-title').text(global.i18n.t('accounts.bankSelector.country_choice'))
        $('#bank-modal-search-container').closest('div').removeClass('visually-hidden')
        $('#bank-modal-search').val('')

        $.ajax({
            url: '/json/institutions/countries',
            method: 'POST',
            data: { _csrf: $("meta[name=_csrf]").attr("content") },
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)

                goCardlessCountries = response.countries.sort()

                let output = ''

                for (var i=0; i< goCardlessCountries.length; i++) {
                    const f = _.filter(globals.vars.countries, function(o) {
                        return o['code'] === goCardlessCountries[i]
                    })

                    if (_.isEmpty(f))
                        continue

                    output += `
                        <div class="col-lg-3 col-sm-6 col-md-6 col-xs-6 p-1" data-name="${f[0].name}">
                            <div class="border border-muted px-2 py-3 goCardless-card country-choice" data-bs="${goCardlessCountries[i]}">
                                <div class="d-flex flex-row align-items-start align-items-center">
                                    <div class="pe-2">
                                        <i class="fi fi-${goCardlessCountries[i].toLowerCase()}"></i>
                                    </div>
                                    <div>${f[0].name}</div>
                                </div>
                            </div>
                        </div>
                        `
                }

                $('.institutions-cards').html(output)

                $('#bank-modal-search').off().on("keyup", function(e) {
                    const filter = new RegExp('^'+$(this).val() as string, 'i')
                        
                    $('div[data-name]').each(function(idx, obj) {
                        if (filter.test($(this).attr('data-name')))
                            $(this).removeClass('visually-hidden')
                        else
                            $(this).addClass('visually-hidden')
                    })
                })

                $('#bank-modal-search').focus()
                        
               
                $('.country-choice').off().on('click', function(e) {
                    e.preventDefault()
        
                    selectedCountry = $(this).attr('data-bs')
                    generateInstitutions()
                })
            },
            error: function (err) {
                helpers.alert(err)
            }
        })

    }

    function generateInstitutions() {       
        $('#bank-selector-modal-title').text(global.i18n.t('accounts.bankSelector.institution_choice'))
        $('#bank-modal-search').val('')

        generateLoading()

        $.ajax({
            url: '/json/institutions/get',
            method: 'POST',
            data: { country: selectedCountry, _csrf: $("meta[name=_csrf]").attr("content") },
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)

                let output = ''
    
                institutions = response

                for (var i=0; i<response.length; i++) {
                    output += `
                        <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12 p-1" data-name="${response[i].name}">
                            <div class="border border-muted px-3 py-3 goCardless-card institution-choice" data-bs="${response[i].id}" title="${response[i].name}">
                                <div class="d-flex flex-row align-items-start align-items-center align-items-stretch">
                                    <div class="avatar-xs me-3">
                                        <div class="avatar-title">
                                            <img src="${response[i].logo}" alt="logo" class="avatar-sm rounded-circle">
                                        </div>
                                    </div>
                                    <div class="text-truncate">${response[i].name}</div>
                                </div>
                            </div>
                        </div>
                        `
                }
    
                $('.institutions-cards').html(output)

                $('#bank-modal-search').off().on("keyup", function(e) {
                    const filter = new RegExp($(this).val() as string, 'i')
                        
                    $('div[data-name]').each(function(idx, obj) {
                        if (filter.test($(this).attr('data-name')))
                            $(this).removeClass('visually-hidden')
                        else
                            $(this).addClass('visually-hidden')
                    })
                })

                $('#bank-modal-search').focus()

                $('#inst-back-1-btn').removeClass('visually-hidden')
                $('#inst-back-2-btn').addClass('visually-hidden')
                $('#inst-final-btn').addClass('visually-hidden')
    
                $('.institution-choice').off().on('click', function(e) {
                    e.preventDefault()
    
                    selectedInstitutionId = $(this).attr('data-bs')

                    const event = new CustomEvent("selectedInstitutionId", {
                        detail: {
                          selectedInstitutionId : selectedInstitutionId
                        }
                    })
                
                    document.dispatchEvent(event)

                    $('#inst-back-1-btn').addClass('visually-hidden')
                    $('#inst-back-2-btn').removeClass('visually-hidden')

                    if (!LockBankSelector) {
                        generateRequisition()
                    } else {
                        $('#bank-selector-modal').modal('hide')
                    }
                })
            },
            error: function (err) {
                helpers.alert(err)
            }
        })
    }

    function generateRequisition() {
        generateLoading()

        const params = {
            institutionId: selectedInstitutionId,
            locales: globals.vars.locales,
            _csrf: $("meta[name=_csrf]").attr("content")
        }

        $.ajax({
            url: '/json/requisition/create',
            method: 'POST',
            data: params,
            success: function (response) {
                if (typeof response['error'] !== 'undefined') {
                    helpers.alert(response)
                }

                if (DEBUG) console.log(response)

                $('#inst-final-form').attr('action', response.link)
                generateConsent()
            },
            error: function (err) {
                helpers.alert(err)
            }
        })
    }

    function generateConsent() {
        const item = _.filter(institutions, function(o) {
            return o.id === selectedInstitutionId
        })

        // const item = [
        //     {
        //         "id": "BANQUEPOPULAIRE_BOURGOGNE_FRANCHE_COMTE_CCBPFRPPDJN",
        //         "name": "Banque Populaire Bourgogne Franche Comté",
        //         "bic": "CCBPFRPPDJN",
        //         "countries": [
        //             "FR"
        //         ],
        //         "logo": "https://storage.googleapis.com/gc-prd-institution_icons-production/FR/PNG/banquepopulaire.png"
        //     }
        // ]

        if (item.length > 0) {
            $('#inst-final-btn').removeClass('visually-hidden')
            $('#bank-modal-search-container').closest('div').addClass('visually-hidden')

            $('#bank-selector-modal-title').text(item[0].name)

            let output = `
            <div class="col-12">
                                <div class="card mb-1 border-0">
                                    <div class="row g-0">
                                        <div class="col-md-4 p-3">
                                            <img src="${item[0].logo}" alt="Card image" class="img-fluid">
                                        </div>
                                        <div class="col-md-8">
                                            <div class="card-body pe-2">
                                                <h3 class="card-title">${global.i18n.t('accounts.bankSelector.finalize_card_title')}</h3>
                                                <p class="card-text text-break pt-3">
                                                    ${global.i18n.t('accounts.bankSelector.finalize_card_content')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
            `

            $('.institutions-cards').html(output)

        }
    }
}



